import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isMobile } from '../utils/MobileCheck';

import {
	ICareerSearchCondition,
	ISelectedCareer,
	setCareerSearchCondition,
} from '../actions/search';
import CategoryTree from '../components/CategoryTree';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import { ISearchState } from '../reducers/search';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import { CMItemCode, isValid } from '../utils/CMData';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		content: {
			margin: 'auto',
		},
		right: {
			float: 'right',
		},
		root: {
			margin: '0 auto',
			padding: 0,
			wordBreak: 'break-all',
		},
	});

interface ISearchProps {
	selectFlg: boolean;
	onSelectEnd: (val: any) => void;
}

interface IState {
	dialogContent: string;
	dialogOpen: boolean;
	dialogReplaceContent: string[];
}

/**
 * カテゴリ検索
 */
class SearchCategory extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			dialogContent: '',
			dialogOpen: false,
			dialogReplaceContent: [],
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (this.props.setCategoryAt) {
			return;
		}
		this.props.fetchCategoryCareerTree(this.props.token);
	}

	/**
	 * プロパティー変更
	 */
	public componentWillReceiveProps(newProps: any) {
		if (newProps.selectFlg) {
			this.handleApply();
		}
	}

	public render() {
		const { classes, categories } = this.props;

		return (
			<div className={classes.root}>
				<Grid container={true}>
					<Grid item={true} xs={true}>
						<div className={classes.content}>
							{categories.data.map((category, i) => (
								<CategoryTree
									key={i}
									{...category}
									selectedCareers={
										this.props.categories.selectedCareers
									}
								/>
							))}
						</div>
					</Grid>
				</Grid>
				<MessageDialog
					open={this.state.dialogOpen}
					showCancelButton={false}
					title={i18n.t('SearchCategory_0001')}
					contents={[
						{
							content: this.state.dialogContent,
							replacements: this.state.dialogReplaceContent,
						},
					]}
					onClose={this.handleCloseConfirmDialog}
					onClickOk={this.handleCloseConfirmDialog}
				/>
			</div>
		);
	}

	/**
	 * 確認ダイアログオープン
	 */
	protected openConfirmDialog(
		dialogContent: string,
		dialogReplaceContent?: string[]
	) {
		if (dialogReplaceContent) {
			this.setState({
				dialogContent,
				dialogOpen: true,
				dialogReplaceContent,
			});
		} else {
			this.setState({ dialogContent, dialogOpen: true });
		}
	}

	/**
	 * 確認ダイアログクローズ
	 */
	protected handleCloseConfirmDialog = () => {
		this.setState({ dialogContent: '', dialogOpen: false });
	};

	/**
	 * 受講申請ボタンハンドラ
	 */
	protected handleApply = () => {
		const selectedCareerIds = this.props.categories.selectedCareers.map(
			(selected: ISelectedCareer): string => selected.careerId
		);
		const selectedCareerTypes = this.props.categories.selectedCareers.map(
			(selected: ISelectedCareer): string => selected.careerType
		);
		const cmFlg: boolean = isValid(CMItemCode.CM_ENABLED);

		// 未選択
		if (selectedCareerIds.length === 0) {
			// CMオプションの設定がONの時
			if (!isMobile() && cmFlg) {
				// 受講申請したい研修・スキル・カリキュラム
				this.openConfirmDialog('LMCM_E_00235', [
					i18n.t('SearchCategory_0002'),
				]);
			} else {
				// 受講申請したい研修・カリキュラム
				this.openConfirmDialog('LMCM_E_00235', [
					i18n.t('SearchCategory_0003'),
				]);
			}
			this.props.onSelectEnd({ err: true });
			return;
		}

		// 研修・カリキュラムの両方が選択されていたらエラー
		const containsCareer: boolean = selectedCareerTypes.indexOf('0') !== -1;
		const containsSkill: boolean = selectedCareerTypes.indexOf('10') !== -1;
		const types: string[] = Array.from(new Set(selectedCareerTypes));
		if (types.length > 1) {
			// CMオプションの設定がONの時
			if (!isMobile() && cmFlg) {
				// 研修・スキル・カリキュラムの分類
				this.openConfirmDialog('LMCM_E_15002', [
					i18n.t('SearchCategory_0004'),
				]);
			} else {
				// 研修・カリキュラムの分類
				this.openConfirmDialog('LMCM_E_15002', [
					i18n.t('SearchCategory_0005'),
				]);
			}
			this.props.onSelectEnd({ err: true });
			return;
		}

		const to = Routes.getPath(Screens.PERSONAL_LECTURE_APPLICATION);
		const state = {
			caller: window.location.pathname,
			careerIDs: selectedCareerIds,
			careerType: containsCareer ? '0' : containsSkill ? '10' : '90',
		};
		const newCondition = { ...this.props.condition };
		newCondition.careerType = state.careerType;
		this.props.setCareerSearchCondition(newCondition);
		this.props.onSelectEnd({ err: false });
		this.props.pushHistory(to, state);
	};
}

const mapStateToProps = (state: IRootState) => ({
	categories: state.search.categories,
	condition: state.search.careerSearchCondition,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCategoryCareerTree: (token: string) => {
		const s = ScenarioFactory.createFetchCategoryCareerTree(
			dispatch,
			token
		);
		s.run({});
	},
	pushHistory: (path: string, state: any) => dispatch(push(path, state)),
	setCareerSearchCondition: (value: ICareerSearchCondition) =>
		dispatch(setCareerSearchCondition({ value })),
});

// tslint:disable-next-line: no-empty-interface
export interface ISearchCategoryProps
	extends Pick<ISearchState, 'setCategoryAt'> {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	ISearchCategoryProps &
	ISearchProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SearchCategory);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SearchCategory.tsx